import React, { useEffect, useRef } from 'react';

const LanguageSwitcher = () => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const loadedRef = useRef(false);

  useEffect(() => {
    if (loadedRef.current || !wrapperRef.current) return;
    loadedRef.current = true;

    window.gtranslateSettings = {
      default_language: "en",
      native_language_names: true,
      languages: ["en", "ar"],
      wrapper_selector: ".gtranslate_wrapper",
    };

    const script = document.createElement('script');
    script.src = 'https://cdn.gtranslate.net/widgets/latest/dropdown.js';
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div
      ref={wrapperRef}
      className="gtranslate_wrapper"
      aria-label="Language switcher"
    />
  );
};

export default LanguageSwitcher;
